export const safeLocalStorage =
  typeof window !== 'undefined'
    ? {
        getItem: (key: string) => {
          const value = window.localStorage.getItem(key);
          return value ? JSON.parse(value) : null;
        },
      }
    : { getItem: (key: string) => null };
